import React, { useState, useCallback, FormEvent } from 'react';
import { useTranslation } from 'react-i18next';

require('./BuildingTextFilter.css');

export type Props = {
    text: string;
    onChange(text: string): void;
};

export const BuildingTextFilter = ({ text, onChange }: Props) => {
    const { t } = useTranslation();
  
    const [ collapsed, setCollapsed ] = useState(false);

    const handleChange = useCallback((e: FormEvent<HTMLInputElement>) => {
        const { value } = e.currentTarget;
        onChange(value);
    }, [ onChange ]);
    
    const handleClickHeader = useCallback(() => {
        setCollapsed(c => !c);
    }, [ setCollapsed ]);

    return (
        <div
            id="building-text-filter"
            className={ `building-filter ${collapsed ? 'collapsed' : ''}` }
        >
            <header
                onClick={ handleClickHeader }
            >
                <i className="ui down triangle icon"/>
                <span>
                    { t('BUILDINGS.FILTERS.NAME') }
                </span>
            </header>
            { !collapsed &&
                <div className="ui labeled input">
                    <input
                        type="text"
                        value={ text }
                        maxLength={ 32 }
                        autoFocus={ true }
                        placeholder={ t('FILTER.SEARCH_PLACEHOLDER') }
                        onChange={ handleChange }
                    />
                </div>
            }
        </div>
    );
};
